import React from 'react';

const LoadingIcon = () => {
  return (
    <div className="loading-icon-container">
      <div className="loading-icon"></div>
    </div>
  );
};

export default LoadingIcon;